import { render } from "./iconAlert.vue?vue&type=template&id=6525a55e"
import script from "./iconAlert.vue?vue&type=script&lang=js"
export * from "./iconAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__